import api from "@/apis/UserSystem/DBOptionAPI";
import Crud from "./crud-base";
var crud = new Crud("dboption", api);

const state = {
  ...crud.state,
  _config: {
    field: {
      key: "DBOptionID",
      code: "OptionID",
      name: "Description",
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: import.meta.env.PROD,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
